"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeUtil = void 0;
var TimeUtil = (function () {
    function TimeUtil() {
    }
    TimeUtil.until = function (date) {
        var now = new Date().getTime();
        return date.getTime() - now;
    };
    TimeUtil.since = function (date) {
        return -this.until(date);
    };
    TimeUtil.elapsed = function (date, date2) {
        return date2.getTime() - date.getTime();
    };
    TimeUtil.secs = function (seconds) {
        return seconds * this.ONE_SECOND;
    };
    TimeUtil.mins = function (minutes) {
        return minutes * this.ONE_MINUTE;
    };
    TimeUtil.hours = function (hours) {
        return hours * this.ONE_HOUR;
    };
    TimeUtil.days = function (days) {
        return days * this.ONE_DAY;
    };
    TimeUtil.parse = function (duration) {
        var ms = 0;
        ms += duration.secs ? this.secs(duration.secs) : 0;
        ms += duration.mins ? this.mins(duration.mins) : 0;
        ms += duration.hours ? this.hours(duration.hours) : 0;
        ms += duration.days ? this.days(duration.days) : 0;
        return ms;
    };
    TimeUtil._duration = function (ms) {
        var years = Math.floor(ms / this.ONE_YEAR);
        ms -= years * this.ONE_YEAR;
        var days = Math.floor(ms / this.ONE_DAY);
        ms -= this.days(days);
        var hours = Math.floor(ms / this.ONE_HOUR);
        ms -= this.hours(hours);
        var mins = Math.floor(ms / this.ONE_MINUTE);
        ms -= this.mins(mins);
        var secs = Math.floor(ms / this.ONE_SECOND);
        return { years: years, days: days, hours: hours, mins: mins, secs: secs };
    };
    TimeUtil.ONE_SECOND = 1000;
    TimeUtil.ONE_MINUTE = 60000;
    TimeUtil.ONE_HOUR = 3600000;
    TimeUtil.ONE_DAY = 86400000;
    TimeUtil.ONE_YEAR = 31557600000;
    return TimeUtil;
}());
exports.TimeUtil = TimeUtil;
//# sourceMappingURL=TimeUtil.js.map